import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [
    // 1. Global settings for wiredConfig.read (data[0])
    {
      "info": {},
      "stpState": true,
      "igmpSnoopingState": true,
      "dhcpState": true,
      "allowedServerIp": "192.168.1.1",
      "jumboFrameState": true,
      "LBDState": true,
      "DDPState": true
    },
    // 2. Device 1: Switch (for ports.read switches)
    {
      "apPorts": [],
      "capabilities": {
        "linkSpeed": [
          {
            "count": 28,
            "t": ["a", "10m", "100m", "1g", "10g"],
            "s": ["a", "1g", "10g"]
          }
        ],
        "poePorts": Array(28).fill(1)
      },
      "info": {
        "deviceType": "switch",
        "deviceName": "DGS-1250-28X FA:00/1",
        "macAddress": "AA:BB:CC:DD:EE:01",
        "modelName": "DGS-1250-28X"
      },
      "switchPorts": [
        {
          "portStaIndex": 1,
          "portName": "DGS-1250-28X FA:00/1",
          "portStaMediaType": 1,
          "portStaSpeed": 9,
          "portStaDuplex": 2,
          "poePowerUsage": 12000,
          "poeClassification": 3
        }
      ],
      "wired.port": [
        {
          "PVID": 1,
          "allowVlan": "1",
          "ddpState": true,
          "deviceCategory": "switch",
          "id": "85dc9562-58d3-8738-9735-ca2139a83819",
          "lbdState": true,
          "operation": {
            "aggregatePort": null,
            "aggregateType": null,
            "mirrorMode": null,
            "mirrorPort": null,
            "type": "switching"
          },
          "poeState": true,
          "portIndex": 1,
          "portName": "DGS-1250-28X FA:00/1",
          "portProfile": "",
          "portState": true,
          "portTags": [],
          "portType": "trunk",
          "speed": "auto",
          "version": 1, 
          "portSchedule": null,
          "rstpState": true,
          "stpState": false,
          "poeSchedule": null,
          "accessPolicy": {
            "enableState": false,
            "type": "STATIC",
            "macList": null,
            "radiusProfile": null,
            "dynamicSize": null
          }
        }
      ]
    },
    // 3. Device 2: Switch (for ports.read switches)
    {
      "apPorts": [],
      "capabilities": {
        "linkSpeed": [
          {
            "count": 28,
            "t": ["a", "10m", "100m", "1g", "10g"],
            "s": ["a", "1g", "10g"]
          }
        ],
        "poePorts": Array(28).fill(1)
      },
      "info": {
        "deviceType": "switch",
        "deviceName": "DGS-1250-28X FA:00/2",
        "macAddress": "FE:DC:BA:98:76:54",
        "modelName": "DGS-1250-28X"
      },
      "switchPorts": [
        {
          "portStaIndex": 2,
          "portName": "DGS-1250-28X FA:00/2",
          "portStaMediaType": 2,
          "portStaSpeed": 4,
          "portStaDuplex: ": 2,
          "poePowerUsage": null,
          "poeClassification": null
        }
      ],
      "wired.port": [
        {
          "PVID": 19,
          "allowVlan": "",
          "ddpState": true,
          "deviceCategory": "switch",
          "id": "aks0312f-58d3-8738-9735-ca2139a83819",
          "lbdState": true,
          "operation": {
            "aggregatePort": null,
            "aggregateType": null,
            "mirrorMode": null,
            "mirrorPort": null,
            "type": "switching"
          },
          "poeState": false,
          "portIndex": 2,
          "portName": "DGS-1250-28X FA:00/2",
          "portProfile": "",
          "portState": true,
          "portTags": ["209133", "ddddd"],
          "portType": "access",
          "speed": "auto",
          "version": 1, 
          "portSchedule": null,
          "rstpState": true,
          "stpState": false,
          "poeSchedule": null,
          "accessPolicy": {
            "enableState": false,
            "type": "STATIC",
            "macList": null,
            "radiusProfile": null,
            "dynamicSize": null
          }
        }
      ]
    },
    // 4. Device 3: Switch (for ports.read switches)
    {
      "apPorts": [],
      "capabilities": {
        "linkSpeed": [
          {
            "count": 26,
            "t": ["a", "10m", "100m", "1g", "10g"],
            "s": ["a", "1g", "10g"]
          }
        ],
        "poePorts": Array(26).fill(1)
      },
      "info": {
        "deviceType": "switch",
        "deviceName": "DGS-1210-26 FA:00/3",
        "macAddress": "AA:BB:CC:DD:EE:02",
        "modelName": "DGS-1210-26"
      },
      "switchPorts": [
        {
          "portStaIndex": 3,
          "portName": "DGS-1210-26 FA:00/3",
          "portStaMediaType": 1,
          "portStaSpeed": 7,
          "portStaDuplex": 1,
          "poePowerUsage": 1500,
          "poeClassification": 1
        }
      ],
      "wired.port": [
        {
          "PVID": 200,
          "allowVlan": "100, 110, 120, 130",
          "ddpState": true,
          "deviceCategory": "switch",
          "id": "85dc9562-ef3f-8738-9735-ca2139a83819",
          "lbdState": true,
          "operation": {
            "aggregatePort": null,
            "aggregateType": null,
            "mirrorMode": null,
            "mirrorPort": null,
            "type": "switching"
          },
          "poeState": false,
          "portIndex": 3,
          "portName": "DGS-1210-26 FA:00/3",
          "portProfile": "",
          "portState": true,
          "portTags": ["11111"],
          "portType": "trunk",
          "speed": "auto",
          "version": 1, 
          "portSchedule": null,
          "rstpState": true,
          "stpState": false,
          "poeSchedule": null,
          "accessPolicy": {
            "enableState": false,
            "type": "STATIC",
            "macList": null,
            "radiusProfile": null,
            "dynamicSize": null
          }
        }
      ]
    },
    // 5. Device 4: AP (for ports.read APs)
    {
      "apPorts": [],
      "capabilities": {
        "linkSpeed": [
          {
            "count": 28,
            "t": ["a", "10m", "100m", "1g", "10g"],
            "s": ["a", "1g", "10g"]
          }
        ],
        "poePorts": Array(28).fill(1)
      },
      "info": {
        "deviceType": "ap",
        "deviceName": "AP-DGS-1250 FA:00/1",
        "macAddress": "AA:BB:CC:DD:EE:01",
        "modelName": "DGS-1250-28X"
      },
      "switchPorts": [
        {
          "portStaIndex": 1,
          "portName": "AP-DGS-1250 FA:00/1",
          "portStaMediaType": 1,
          "portStaSpeed": 9,
          "portStaDuplex": 2,
          "poePowerUsage": 0,
          "poeClassification": 0
        }
      ],
      "wired.port": [
        {
          "PVID": 10,
          "allowVlan": "",
          "ddpState": true,
          "deviceCategory": "ap",
          "id": "85dc9562-58d3-8738-9735-ca2139a83819-ap",
          "lbdState": true,
          "operation": {
            "aggregatePort": null,
            "aggregateType": null,
            "mirrorMode": null,
            "mirrorPort": null,
            "type": "switching"
          },
          "poeState": true,
          "portIndex": 1,
          "portName": "AP-DGS-1250 FA:00/1",
          "portProfile": "",
          "portState": true,
          "portTags": ["33333"],
          "portType": "access",
          "speed": "auto",
          "version": 1, 
          "portSchedule": null,
          "rstpState": true,
          "stpState": false,
          "poeSchedule": null,
          "accessPolicy": {
            "enableState": false,
            "type": "STATIC",
            "macList": null,
            "radiusProfile": null,
            "dynamicSize": null
          }
        }
      ]
    },
    // 6. Device 5: AP (for ports.read APs)
    {
      "apPorts": [],
      "capabilities": {
        "linkSpeed": [
          {
            "count": 28,
            "t": ["a", "10m", "100m", "1g", "10g"],
            "s": ["a", "1g", "10g"]
          }
        ],
        "poePorts": Array(28).fill(1)
      },
      "info": {
        "deviceType": "ap",
        "deviceName": "AP-DGS-1250 FA:00/2",
        "macAddress": "FE:DC:BA:22:70:54",
        "modelName": "DGS-1250-29"
      },
      "switchPorts": [
        {
          "portStaIndex": 2,
          "portName": "AP-DGS-1250 FA:00/2",
          "portStaMediaType": 1,
          "portStaSpeed": 7,
          "portStaDuplex": 1,
          "poePowerUsage": 1500,
          "poeClassification": 1
        }
      ],
      "wired.port": [
        {
          "PVID": 19,
          "allowVlan": "",
          "ddpState": true,
          "deviceCategory": "ap",
          "id": "aks0312f-58d3-8738-9735-ca2139a83819-ap",
          "lbdState": true,
          "operation": {
            "aggregatePort": null,
            "aggregateType": null,
            "mirrorMode": null,
            "mirrorPort": null,
            "type": "switching"
          },
          "poeState": true,
          "portIndex": 2,
          "portName": "AP-DGS-1250 FA:00/2",
          "portProfile": "",
          "portState": true,
          "portTags": [],
          "portType": "access",
          "speed": "auto",
          "version": 1, 
          "portSchedule": null,
          "rstpState": true,
          "stpState": false,
          "poeSchedule": null,
          "accessPolicy": {
            "enableState": false,
            "type": "STATIC",
            "macList": null,
            "radiusProfile": null,
            "dynamicSize": null
          }
        }
      ]
    },
    // 7. Device 6: AP (for ports.read APs)
    {
      "apPorts": [],
      "capabilities": {
        "linkSpeed": [
          {
            "count": 28,
            "t": ["a", "10m", "100m", "1g", "10g"],
            "s": ["a", "1g", "10g"]
          }
        ],
        "poePorts": Array(28).fill(1)
      },
      "info": {
        "deviceType": "ap",
        "deviceName": "AP-DGS-1250 FA:00/3",
        "macAddress": "FE:DC:BA:98:76:54",
        "modelName": "DGS-1250-28X"
      },
      "switchPorts": [
        {
          "portStaIndex": 3,
          "portName": "AP-DGS-1250 FA:00/3",
          "portStaMediaType": 2,
          "portStaSpeed": 4,
          "portStaDuplex": 2,
          "poePowerUsage": 12000,
          "poeClassification": 5
        }
      ],
      "wired.port": [
        {
          "PVID": 200,
          "allowVlan": "100, 110, 120, 130",
          "ddpState": true,
          "deviceCategory": "ap",
          "id": "85dc9562-ef3f-8738-9735-ca2139a83819-ap",
          "lbdState": true,
          "operation": {
            "aggregatePort": null,
            "aggregateType": null,
            "mirrorMode": null,
            "mirrorPort": null,
            "type": "switching"
          },
          "poeState": true,
          "portIndex": 3,
          "portName": "AP-DGS-1250 FA:00/3",
          "portProfile": "",
          "portState": true,
          "portTags": ["22222"],
          "portType": "trunk",
          "speed": "auto",
          "version": 1, 
          "portSchedule": null,
          "rstpState": true,
          "stpState": false,
          "poeSchedule": null,
          "accessPolicy": {
            "enableState": false,
            "type": "STATIC",
            "macList": null,
            "radiusProfile": null,
            "dynamicSize": null
          }
        }
      ]
    }
  ]
};

export const wiredSlice = createSlice({
  name: "wired",
  initialState,
  reducers: {},
});

export default wiredSlice.reducer;
